import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_IMROOM_URL,
    crossDomain: true,
    headers: {
        "Accept": "application/json"
    }
})